import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useConsultantNetworkSearch = (id, term) => useQuery({ queryKey: [`${id}-network-${term}`], queryFn: async () => {
    if(!term) return []
    const callback = await API.get(`/consultants/${id}/network/search?term=${term}`)
    return callback?.data
}})

export default useConsultantNetworkSearch